export default __webpack_public_path__ + "static/media/affiliates.6efbb57e.svg";